(function addLanguageFlag() {
  // Try to find the language button every 200ms until it exists (max 5 seconds)
  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    var btn = document.querySelector('.language-selector');
    if (!btn) return;

    var span = btn.querySelector('span');
    if (!span) return;

    // Determine flag based on span text
    var text = span.textContent.trim();
    var flag = '🌐'; // fallback
    if (/Български|Bulgarian/i.test(text)) flag = '🇧🇬';
    else if (/English|Английски/i.test(text)) flag = '🇬🇧';
    else if (/Español|Spanish/i.test(text)) flag = '🇪🇸';

    // Prepend flag only if not already added
    if (!span.dataset.flagAdded) {
      span.textContent = flag + ' ' + text;
      span.dataset.flagAdded = "true"; // mark as added
    }

    // Stop checking once done or after 25 attempts (~5s)
    clearInterval(interval);
  }, 200);
})();
